import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from 'components/shared';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

const TooltipContent = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  text-align: start;
  margin-bottom: 8px;
  background: #ffffff;
  color: var(--color-primary);
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 24px 0 rgba(0,0,0,0.08), 0 1.5px 4px 0 rgba(0,0,0,0.03);
  border: 1px solid #e5e7eb;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  white-space: nowrap;
  z-index: 1000;
  opacity: ${props => props.isVisible ? 1 : 0};
  visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  max-width: 300px;
  min-width: 160px;
  white-space: normal;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #ffffff;
  }

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #e5e7eb;
    margin-top: 1px;
  }
`;

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const StyledIcon = styled(Icon)` 
  margin-left: 0.5rem;
`;

const ScheduleTooltip = ({ text, children, width = 1 }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return (
    <TooltipContainer
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      <IconWrapper>
        {children || <StyledIcon icon='tooltip_icon' width={width} />}
      </IconWrapper>
      <TooltipContent isVisible={isVisible}>
        {text}
      </TooltipContent>
    </TooltipContainer>
  );
};

export default ScheduleTooltip;
